import React, { useState } from 'react';
import './MeasroDashboard.css';

import logo from "../../asset/img/colorbg.png";

const ReportTop = ({projectDetails, id}) => {
   

  // console.log("projectDetails", projectDetails);

    return (

        <>
        
    <div className="top-header">
  <div className="logo-area">
    <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    <div className="sub-brand  text-white">Project Management Dashboard</div>
    </div>
    
  </div>
  <div className="address-container">
    <div className="address-icon">
      <i className="fas fa-map-marker-alt" />
    </div>
    <div className="address-text">{projectDetails?.address}</div>
  </div>
  <div className="property-id">
    Property ID: {id} 
    {/* | Last Updated: 11/7/2025 */}
  </div>
</div>


        </>

        
    );
};

export default ReportTop; 